import {Injectable} from "@angular/core";
import { Http } from "@angular/http";
import {
    ITCIExecHistory,
    ITCIExecHistoryListPageOutput
} from "@tci/common";
import { Subject } from "rxjs";

@Injectable()
export class BaseAppExecHistoryService {
    private static instance: BaseAppExecHistoryService = null;
    private refresh$: Subject<ITCIExecHistoryListPageOutput> = new Subject();
    private setRowData$: Subject<ITCIExecHistory> = new Subject();

    public static getInstance(http: Http) {
        if (!BaseAppExecHistoryService.instance) {
            BaseAppExecHistoryService.instance = new BaseAppExecHistoryService(http);
        }
        return BaseAppExecHistoryService.instance;
    }

    constructor(private http: Http) {
    }

    getRefreshSubject() {
        return this.refresh$;
    }

    refreshByPage(e: ITCIExecHistoryListPageOutput) {
        return this.refresh$.next(e);
    }

    getSetRowDataSubject() {
        return this.setRowData$;
    }

    setRowData(e: ITCIExecHistory) {
        this.setRowData$.next(e);
    }
}

